<template>
  <div class="text-center">

    <div class="normal-product-button-section" v-if="checkProductOnShoppingCart(product) && product.is_digital">
      <m-a :href="{name:shoppingCartLink()}">
        <button class="btn btn-primary rounded-pill normal-product-button-main"
                v-t="`product.single.shopping_cart`"></button>
      </m-a>
    </div>

    <div v-else>
      <del class="normal-product-offer" v-if="calculatePriceAndOffer(product)['offer'] > 0">
        <h3 class="m-auto text-muted"
            v-html="$t('price.price', {currency: formatNumber(parseInt(calculatePriceAndOffer(product)['price']))})"></h3>
      </del>
      <h2 class="normal-product-price m-auto"
          v-html="$t('price.price',{currency:formatNumber(parseInt(calculatePriceAndOffer(product)['price'] ) - calculatePriceAndOffer(product)['offer'])})">
      </h2>

      <div class="my-2"
           v-if="findAttributeOnSiteInfo('product_unit_warning')[0] >= product.quantity && !isNaN(parseInt(product.quantity)) && product.quantity != 0">
        <p>
          {{ $t('product.quantity_warning', {quantity: product.quantity}) }}
        </p>
      </div>
      <div class="normal-product-button-section" v-if="checkProductOnShoppingCart(product)">
        <m-shopping-cart-quantity-manager1 class="" @updateQuantity="checkProductOnShoppingCart(product)"
                                           :show-trash-only-in-first-quantity="showTrashOnlyInFirstQuantity"
                                           :product="product"/>
        <m-a :href="{name:shoppingCartLink()}" class="normal-product-shopping-card-link">
          <button class="btn btn-primary rounded-pill normal-product-button-main"
                  v-t="`product.single.shopping_cart`"></button>
        </m-a>
      </div>
      <div class="normal-product-button-section" v-else>

        <template v-if="quantityChecker(1,product,null)">
          <button
              v-if="isCartTypeOnUnAuthenticated()"
              @click="addToCartWrapper(product,null)"
              class=" normal-product-button-main btn rounded-pill row text-white btn-primary"
              v-t="`product.add_to_cart_physical`">
          </button>
          <div class="mt-3" v-else>
            <m-a :href="{name:'Login'}">
              <div class="btn btn-primary" v-t="`product.single.register_button`"></div>
            </m-a>
            <p v-t="`product.single.register_button_description`"></p>
          </div>
        </template>

        <template v-else>
          <button class=" normal-product-button-main btn rounded-pill row text-white btn-primary product-card-price-200-out-of-quantity" v-t="`product.out_of_quantity`"></button>
        </template>


      </div>
    </div>
  </div>
</template>

<script>
import {
  quantityChecker,
  shoppingCartFunctions
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import mA from '../../Tags/A'
import mShoppingCartQuantityManager1 from '../ShoppingCartQuantityManager1'
import {mapGetters} from "vuex";

export default {
  name: "NormalProduct",
  props: {
    product: {},
    showTrashOnlyInFirstQuantity: {
      default: false
    }
  },
  components: {
    mA,
    mShoppingCartQuantityManager1,
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated',
      order: "ShoppingCart/getSidebarBasketData",
    }),
  },
  methods: {
    quantityChecker,
    ...shoppingCartFunctions,
    async addToCartWrapper() {
      // create this function to do some stuff after we add item to order
      await this.addToCart(...arguments)
      await this.refreshComponent()
    },

    refreshComponent() {
      this.$forceUpdate();
    },
  },
  mounted() {
    window.addEventListener('click', this.refreshComponent);
    window.addEventListener('DOMContentLoaded', this.refreshComponent);
  },
}
</script>

<style scoped>

</style>